import { useEffect, useState } from "react";
import "../styles/countdown-offer.css";

const CountdownOffer = () => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  useEffect(() => {
    const targetDate = new Date("2025-07-23T08:30:00+07:00").getTime();

    const updateCountdown = () => {
      const now = new Date().getTime();
      const distance = targetDate - now;

      if (distance < 0) return;

      setTimeLeft({
        days: Math.floor(distance / (1000 * 60 * 60 * 24)),
        hours: Math.floor((distance / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((distance / (1000 * 60)) % 60),
        seconds: Math.floor((distance / 1000) % 60),
      });
    };

    const timer = setInterval(updateCountdown, 1000);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="countdown-offer">
      {/* <p className="countdown-offer__text">
        <strong className="countdown-offer__highlight">
          Hạn chót đăng ký & tham gia trải nghiệm
        </strong>{" "}
        đến{" "}
        <strong className="countdown-offer__highlight">
          8h30 sáng, ngày 23/07/2025
        </strong>
        !
      </p> */}
      {/* <p className="countdown-offer__subtext">
        Tham gia trực tiếp và online từ xa
      </p> */}

      {/* <div className="countdown-offer__timer">
        <span className="countdown-offer__label">⏱️ Thời gian còn lại:</span>
        <span>{timeLeft.days}d</span>
        <span>{timeLeft.hours}h</span>
        <span>{timeLeft.minutes}m</span>
        <span>{timeLeft.seconds}s</span>
      </div> */}
      <div className="countdown-offer__qr">
        <img
          src="/qr.jpg"
          alt="QR Code đăng ký"
          className="countdown-offer__qr-img"
        />
        <p className="countdown-offer__qr-caption">
          Quét mã QR để tham gia ngay!
        </p>
      </div>
      <div className="countdown-offer__zalo-group">
        <a
          href="https://zalo.me/g/mohngo916"
          className="zalo-group-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          🔗 Tham gia nhóm Zalo hỗ trợ trực tiếp
        </a>
      </div>
    </div>
  );
};

export default CountdownOffer;
